import {CloseIcon} from '@prtimes-basis/icons';
import {useMemo} from 'react';
import {useController} from 'react-hook-form';
import {useMasterData} from '../../../../../components/master-data-provider';
import styles from './business-categories-field.module.css';
import {Pulldown} from '@/features/company-registration/components/pulldown';
import {FormField} from '@/features/company-registration/steps/input-step/form-field';
import {useCompanyRegistrationFormContext} from '@/features/company-registration/form';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function BusinessCategoriesField() {
  return (
    <FormField.Root name='companyInfo.businessCategoryLv2Ids'>
      <Body />

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {control} = useCompanyRegistrationFormContext();
  const {
    field: {name, value, onChange},
    fieldState: {error},
  } = useController({
    control,
    name: 'companyInfo.businessCategoryLv2Ids',
  });

  const isError = error?.message !== undefined;

  const onChangeFor = (index: number) => (v: string) => {
    const newValue = [...value];
    newValue[index] = v;
    onChange(newValue);
  };

  const clearAt = (index: number) => {
    const newValue = [...value];
    newValue[index] = '';
    onChange(newValue);
  };

  const masterData = useMasterData();
  const options = useMemo(
    () =>
      masterData?.businessCategory.flatMap(
        (c1) =>
          c1.lv2?.map((c2) => ({
            key: c2.name,
            value: c2.id.toString(),
          })) ?? [],
      ) ?? [],
    [masterData?.businessCategory],
  );

  return (
    <fieldset className={styles.container}>
      <legend className={companyRegistrationPageStyles.srOnly}>
        ビジネスカテゴリ
      </legend>
      <div className={styles.pulldownRow}>
        <Pulldown
          key={`${name}-1-${value[0]}`}
          id={`${name}-1`}
          name={name}
          placeholder='選択してください'
          value={value[0]}
          options={options}
          error={isError}
          aria-describedby={`${name}-error`}
          className={styles.pulldown}
          aria-label='ビジネスカテゴリ1'
          onChange={onChangeFor(0)}
        />
        <button
          type='button'
          className={styles.clearButton}
          aria-disabled={value[0] === ''}
          aria-label='ビジネスカテゴリ1をクリア'
          onClick={() => {
            if (value[0] !== '') {
              clearAt(0);
            }
          }}
        >
          <CloseIcon
            aria-hidden='true'
            className={styles.clearIcon}
            variant='gray'
          />
        </button>
        <Pulldown
          key={`${name}-2-${value[1]}`}
          id={`${name}-2`}
          name={name}
          placeholder='選択してください'
          value={value[1]}
          options={options}
          error={isError}
          aria-describedby={`${name}-error`}
          className={styles.pulldown}
          aria-label='ビジネスカテゴリ2'
          onChange={onChangeFor(1)}
        />
        <button
          type='button'
          className={styles.clearButton}
          aria-disabled={value[1] === ''}
          aria-label='ビジネスカテゴリ2をクリア'
          onClick={() => {
            if (value[1] !== '') {
              clearAt(1);
            }
          }}
        >
          <CloseIcon
            aria-hidden='true'
            className={styles.clearIcon}
            variant='gray'
          />
        </button>
      </div>
      <div className={styles.pulldownRow}>
        <Pulldown
          key={`${name}-3-${value[2]}`}
          id={`${name}-3`}
          name={name}
          placeholder='選択してください'
          value={value[2]}
          options={options}
          error={isError}
          aria-describedby={`${name}-error`}
          className={styles.pulldown}
          aria-label='ビジネスカテゴリ3'
          onChange={onChangeFor(2)}
        />
        <button
          type='button'
          className={styles.clearButton}
          aria-disabled={value[2] === ''}
          aria-label='ビジネスカテゴリ3をクリア'
          onClick={() => {
            if (value[2] !== '') {
              clearAt(2);
            }
          }}
        >
          <CloseIcon
            aria-hidden='true'
            className={styles.clearIcon}
            variant='gray'
          />
        </button>
      </div>
    </fieldset>
  );
}
